export const billingPreferences = {
    NO_PREFERENCE : 0,
    SIMPLIFIED : 100,
    COMPLETE : 200,
};

